export default __webpack_public_path__ + "static/media/upload-image.5d936091.svg";